import { defineComponent } from 'vue';
export default defineComponent({
  props: {
    id: {},
    modelValue: {},
    type: {
      default: 'box'
    },
    disabled: {
      default: false
    }
  }
});